export const testimonials = [
  {
    text: "Adding these entertainment machines to our location has been a seamless experience. They are well-maintained, easy to use, and generate steady additional revenue without disrupting daily operations.",
    name: "Rohit Malhotra",
    rating: 5,
  },
  {
    text: "The setup exceeded our expectations. Installation was quick, support has been reliable, and the machines consistently perform well with strong customer engagement.",
    name: "Angela Brooks",
    rating: 5,
  },
  {
    text: "What stands out most is the professionalism and transparency. From reporting to servicing, everything is handled efficiently, allowing us to focus fully on our business.",
    name: "Mustafa Rahman",
    rating: 4,
  },
  {
    text: "The machines have proven to be a dependable source of passive income. Customers enjoy them, and maintenance has been completely hassle-free.",
    name: "Daniel Kowalski",
    rating: 5,
  },
  {
    text: "The addition of these machines has noticeably improved customer dwell time. It’s a smart way to enhance the customer experience while earning supplemental revenue.",
    name: "Meera Iyer",
    rating: 5,
  },
  {
    text: "We appreciate how smoothly everything runs. The machines are modern, reliable, and supported by a team that responds quickly when needed.",
    name: "Luca Romano",
    rating: 4,
  },
  {
    text: "From compliance to upkeep, the entire process feels structured and professional. This partnership has added real value with minimal effort on our side.",
    name: "Farhan Siddiqui",
    rating: 5,
  },
  {
    text: "These machines have become a popular feature with our customers. They are intuitive to use and consistently operational, which reflects strong backend support.",
    name: "Isabella Conti",
    rating: 4,
  },
  {
    text: "This has been one of the easiest revenue additions we’ve implemented. Clear communication, dependable machines, and consistent performance throughout.",
    name: "Jacob Anderson",
    rating: 5,
  },
];
